import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin } from 'lucide-react';
import Seo from '../components/Seo';
import { FaqSection, faqJsonLd } from '../components/FaqSection';
import { BUSINESS, ADDRESS_LINE } from '../data/seoContent';

const FaqPage = () => (
  <>
    <Seo page="/faq" jsonLd={faqJsonLd} />
    <div className="pt-36" data-testid="faq-page">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="font-['Barlow_Condensed'] text-4xl sm:text-5xl lg:text-6xl font-bold uppercase text-[#0E3D95] mb-4">
          Hot Tub, Sauna & Cold Plunge Questions
        </h1>
        <p className="text-lg text-slate-600 mb-4">
          Answers from the wellness experts at {BUSINESS.name}. Still have a question? We're happy to help.
        </p>
        <div className="flex flex-wrap gap-4 text-[#0E3D95] font-semibold">
          <a href={`tel:${BUSINESS.tel}`} className="inline-flex items-center gap-2 hover:text-[#F88200]" data-testid="faq-call-link"><Phone size={18} /> {BUSINESS.phone}</a>
          <Link to="/contact" className="inline-flex items-center gap-2 hover:text-[#F88200]" data-testid="faq-showroom-link"><MapPin size={18} /> {ADDRESS_LINE}</Link>
        </div>
      </div>
      <FaqSection heading="Frequently Asked Questions" />
    </div>
  </>
);

export default FaqPage;
